var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1516 11.596L17.4269 13.8713C17.7434 14.1878 17.7434 14.701 17.4269 15.0176C15.7156 16.7289 13.0063 16.9214 11.0702 15.4693L9.96191 14.6381C8.21838 13.3304 6.66955 11.7816 5.3619 10.0381L4.53067 8.92979C3.07858 6.99367 3.27112 4.28443 4.98243 2.57313C5.29896 2.2566 5.81215 2.2566 6.12868 2.57313L8.404 4.84845C8.79453 5.23897 8.79453 5.87214 8.404 6.26266L7.57488 7.09178C7.43063 7.23603 7.39487 7.45641 7.4861 7.63887C8.54091 9.74849 10.2515 11.4591 12.3611 12.5139C12.5436 12.6051 12.764 12.5694 12.9082 12.4251L13.7373 11.596C14.1279 11.2055 14.761 11.2055 15.1516 11.596Z",
    stroke: "url(#paint0_radial_100_3089)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_100_3089",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.19512 16.7692) rotate(-41.5346) scale(21.1138 56.9075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNumber);
export default __webpack_public_path__ + "static/media/ContactNumber.9cc82bf863cded708af5fb85b13af6aa.svg";
export { ForwardRef as ReactComponent };